import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoBoxComponent } from '@reconcept-platform/shared/ui/standalone/info-box';

export interface SelectableSearchResult<ValueType = any> {
  label: string;
  description: string;
  value: ValueType;
}

@Component({
  selector: 'rcp-search-results',
  template: `
    <div class="results-container">
      @if (!results?.length) {
        <rcp-info-box color="alert">{{ 'qz-no-results-were-found-zm' | translate }}</rcp-info-box>
      }

      @if (!!results?.length) {
        @for (result of results; track result) {
          <div class="list-item clickable" (click)="onClickResult(result)">
            <div>
              <div class="text-label">
                {{ result.label }}
              </div>
              @if (!!result.description) {
                <div class="text-description">
                  {{ result.description }}
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  `,
  imports: [TranslatePipe, InfoBoxComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SearchResultsComponent {
  @Input() results: SelectableSearchResult[];

  @Output() clickResult = new EventEmitter<SelectableSearchResult>();
  @Output() hide = new EventEmitter<void>();

  setSearchResults(searchResults: SelectableSearchResult[]) {
    this.results = searchResults;
  }

  onClickResult(result: SelectableSearchResult) {
    this.clickResult.emit(result);
    this.onHide();
  }

  onHide() {
    this.hide.emit();
  }
}
